import React, { Component } from "react";
import { connect } from "react-redux";

import {
  ModalContainer,
  WebContainer,
  Wrapper,
  Copy,
  Input,
  Card,
  Row,
  CardBody,
  Spin,
  Bold,
  Button
} from "app/NativeComponents/common";
import { Header, PillButton, Select } from "app/NativeComponents/snippets";

import {
  updateTeamPhoneNumber,
  appRedirect,
  getTeamPhoneNumbers,
  dismissMobileKeyboard
} from "app/NativeActions";

import OnboardingText from "app/DealMachineCore/snippets/OnboardingText";

class PurchasePhoneNumber extends Component {
  constructor(props) {
    super(props);

    this.state = {
      area_code: "",
      forwarding_number: null,
      custom_number: "",
      forwarding_number_options: this.assembleForwardingNumberArray(
        props.available_forwarding_numbers
      )
    };

    this.confirmPurchase = this.confirmPurchase.bind(this);
  }

  assembleForwardingNumberArray(available_forwarding_numbers) {
    let forwarding_number_options = [];
    if (available_forwarding_numbers) {
      for (let i = 0; i < available_forwarding_numbers.length; i++) {
        forwarding_number_options.push({
          label: available_forwarding_numbers[i],
          value: available_forwarding_numbers[i]
        });
      }
    }
    forwarding_number_options.push({
      label: "New Phone Number",
      value: "new_number"
    });

    return forwarding_number_options;
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.available_forwarding_numbers !==
      this.props.available_forwarding_numbers
    ) {
      this.setState({
        forwarding_number_options: this.assembleForwardingNumberArray(
          this.props.available_forwarding_numbers
        )
      });

      if (
        this.props.available_forwarding_numbers &&
        this.props.available_forwarding_numbers.length > 0 &&
        !this.state.forwarding_number
      ) {
        this.setState({
          forwarding_number: this.props.available_forwarding_numbers[0]
        });
      }
    }
  }

  componentDidMount() {
    this.props.getTeamPhoneNumbers({ token: this.props.token });
  }

  handleBack() {
    dismissMobileKeyboard();
    this.props.appRedirect({
      redirect: "goBack",
      payload: { remove: "add-phone-number" }
    });
  }

  renderSaveButton() {
    if (this.state.area_code && this.state.area_code.length == 3) {
      return (
        <Row style={{ justifyContent: "flex-end" }}>
          <PillButton onPress={this.confirmPurchase} primary={true}>
            Add Phone Number
          </PillButton>
        </Row>
      );
    }
  }

  confirmPurchase() {
    this.props.updateTeamPhoneNumber({
      token: this.props.token,
      type: "purchase_number",
      area_code: this.state.area_code,
      forwarding_number:
        this.state.forwarding_number == "new_number"
          ? this.state.custom_number
          : this.state.forwarding_number
    });
  }

  renderPhoneInput() {
    if (this.state.forwarding_number == "new_number") {
      return (
        <Input
          ref="new_forwarding_number"
          name="new_forwarding_number"
          mask_type={"cel-phone"}
          returnKeyType={"done"}
          blurOnSubmit={true}
          autoCapitalize="none"
          keyboardType="numeric"
          placeholder="Phone Number"
          onChange={value =>
            this.setState({
              custom_number: value
            })
          }
          onSubmitEditing={() => {}}
          value={this.state.custom_number}
          type="text"
          mask={"(999) 999-9999"}
        />
      );
    }
  }

  renderForwardingNumbers() {
    if (this.props.team_phone_numbers_loading) {
      return (
        <Card>
          <CardBody>
            <Row>
              <Spin size="small" />
              <Copy style={{ marginLeft: 10 }}>Loading...</Copy>
            </Row>
          </CardBody>
        </Card>
      );
    }

    return (
      <Card>
        <Select
          item_ref={"forwarding_number"}
          items={this.state.forwarding_number_options}
          title="Forwarding Number"
          label="Select a phone number to forward calls"
          value={this.state.forwarding_number}
          text={
            this.state.forwarding_number === "new_number"
              ? "New Phone Number"
              : this.state.forwarding_number
              ? this.state.forwarding_number
              : "Not Selected"
          }
          onSelect={item => {
            this.setState({
              forwarding_number: item
            });
          }}
        />
        {this.renderPhoneInput()}
      </Card>
    );
  }

  render() {
    return (
      <ModalContainer>
        <Header
          title="Add Phone Number"
          leftButtonIcon={"arrow-back"}
          leftButtonAction={() => this.handleBack()}
        />
        <WebContainer>
          <Wrapper style={{ padding: 20 }}>
            <OnboardingText
              slug="purchasePhoneNumber"
              style={{
                padding: 0
              }}
              innerStyle={{
                padding: 20
              }}
            />

            <Card>
              <Wrapper>
                <Input
                  ref="area_code"
                  name="area_code"
                  returnKeyType="next"
                  blurOnSubmit={false}
                  autoCapitalize="words"
                  keyboardType="default"
                  placeholder="Area Code"
                  onChange={value => {
                    this.setState({
                      area_code: value
                    });
                  }}
                  onSubmitEditing={() => {}}
                  value={this.state.area_code}
                  type="number"
                  maxLength={3}
                />
              </Wrapper>
            </Card>
            {this.renderForwardingNumbers()}

            {this.renderSaveButton()}
          </Wrapper>
        </WebContainer>
      </ModalContainer>
    );
  }
}

const mapStateToProps = ({ auth, settings, native, message }) => {
  const { token, user, onboarding } = auth;
  const { colors } = settings;
  const { device, platform, isMobile } = native;
  const { available_forwarding_numbers, team_phone_numbers_loading } = message;
  return {
    token,
    user,
    colors,
    onboarding,
    device,
    platform,
    isMobile,

    team_phone_numbers_loading,
    available_forwarding_numbers
  };
};

export default connect(mapStateToProps, {
  updateTeamPhoneNumber,
  getTeamPhoneNumbers,
  appRedirect
})(PurchasePhoneNumber);
